import _ from 'lodash';
import {
	Beneficiary,
	ValidateBankAccount,
	paymentsMethodType,
	paymentsMethodsMapping,
} from 'constants/beneficiary.constants';

export function prepareBeneficiaryForCreation(beneficiary: Beneficiary, paymentOptions: paymentsMethodType) {
	let bn: ValidateBankAccount = {
		beneficiaryId: Number(beneficiary.id),
		currencyId: Number(beneficiary.currencyId),
		bankAccountCountryId: Number(beneficiary.bankAccountCountryId),
		bankAccountHolderName: String(beneficiary.bankAccountHolderName).trim(),
		regular: [],
		priority: [],
		foreignTradeAgreement: true,
		isSigned: true,
	};

	if (beneficiary?.commentForUnequalCountries) {
		bn['commentForUnequalCountries'] = String(beneficiary.commentForUnequalCountries).trim();
	}

	if (beneficiary.files && Array.isArray(beneficiary.files) && beneficiary.files.length > 0) {
		// Filter only new files
		const newFiles = beneficiary.files.filter((file) => file.id && !file.fileId);
		const fileIds = newFiles.map((file) => file.id);
		bn['fileIds'] = fileIds;
	} else {
		bn['fileIds'] = [];
	}

	beneficiary.formalBankApproveFile &&
		_.assign(bn, { formalBankApproveFileId: beneficiary.formalBankApproveFile.id });
	beneficiary.website && _.assign(bn, { website: beneficiary.website?.trim() });
	beneficiary.comment && _.assign(bn, { comment: beneficiary.comment?.trim() });
	beneficiary.userEditComment && _.assign(bn, { userEditComment: beneficiary.userEditComment?.trim() });
	if (beneficiary.paymentCategories && beneficiary.paymentCategories.length > 0) {
		_.assign(bn, { allowedPaymentCategoryIds: beneficiary.paymentCategories.map((id) => Number(id)) });
	}

	_.keys(paymentOptions).forEach((key) => {
		if (paymentOptions[key].optional) {
			let obj: { [key: string]: string } = {};
			paymentOptions[key].fields.forEach((field) => {
				if (_.has(paymentsMethodsMapping, field)) {
					//@ts-ignore
					obj[paymentsMethodsMapping[field]] = _.get(beneficiary, paymentsMethodsMapping[field])?.trim();
				}
				/*switch (field) {
                    case 'acct_number':
                        obj.acctNumber = beneficiary.acctNumber || '';
                        break;
                    case 'bic_swift':
                        obj.bicSwift = beneficiary.bicSwift || '';
                        break;
                    default:
                        obj[field] = beneficiary[field];
                }*/
			});
			bn[paymentOptions[key].type].push(obj);
		}
	});

	return bn;
}

export const commentLabel = `page.beneficiary.create.step.2.notes.comment.text`;
export const prefixDetails = `page.beneficiary.create.step.3.beneficiary_details.`;
export const prefixBankDetails = `page.beneficiary.create.step.3.beneficiary_bank_details.`;
export const fileLabel = `page.beneficiary.create.step.2.notes.title`;
export const formalBankApproveFileLabel = `page.beneficiary.create.step.2.formalBankApprove.title`;

export const getLabel = (details, index, t) => {
	let label = t(`${prefixDetails}${_.snakeCase(_.keys(details)[index])}.text`);
	label = _.keys(details)[index] === 'files' ? t(fileLabel) : label;
	label = _.keys(details)[index] === 'formalBankApproveFile' ? t(formalBankApproveFileLabel) : label;
	label = _.keys(details)[index] === 'comment' ? t(commentLabel) : label;
	return label;
};
